export default "__VITE_ASSET__DCCeVvMd__"